import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
// nm2024 themed components
import { LinkNm2024  } from '../../../../nm2024Theme/components/link/styles';

export const LinkStyled = styled(LinkNm2024)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: block;
      ${mediumUp && `
        display: inline-block;
        margin-left: ${rem(16)};
      `}
    `;
  }
}`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const verticalPadding = mediumUp ? rem(52) : rem(48);
    return css`
      padding-top: ${verticalPadding};
      padding-bottom: ${verticalPadding};
    `;
  }
}`;
